import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Text } from '@vio/atlas/Text';
import { useGetRoomLabels } from 'components/Offer/hooks/useGetRoomLabels';
import { SplitBookingOfferInfo } from 'components/Offer/types';
import { getSingleFlowSplitBookingDetails } from 'modules/sapiSearch/selectors';
import { equals, intersection, last } from 'ramda';
import { Hotel } from '@findhotel/sapi';
export interface Props {
  /** Hotel Id */
  hotelId: Hotel['objectID'];
  /** Offer state */
  offers: SplitBookingOfferInfo[];
}
const _exp = /*#__PURE__*/() => Text;
const RoomLabelsText = /*#__PURE__*/styled(_exp())({
  name: "RoomLabelsText",
  class: "r1y838gy",
  propsAsIs: true
});
const RoomLabelsItem = /*#__PURE__*/styled('span')({
  name: "RoomLabelsItem",
  class: "rneimk9",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => RoomLabelsText;
const Dot = /*#__PURE__*/styled(_exp6())({
  name: "Dot",
  class: "d17s681g",
  propsAsIs: true
});
export const SingleFlowBundleRoomLabels = ({
  hotelId,
  offers
}: Props) => {
  const {
    cancellationPenalties
  } = useSelector(state => getSingleFlowSplitBookingDetails(state, hotelId));
  const [first, second] = offers;
  const translatedLabelsFirstOffer = useGetRoomLabels({
    offer: {
      ...first?.offer,
      cancellationPenalties
    },
    isSplitBooking: true
  });
  const translatedLabelsSecondOffer = useGetRoomLabels({
    offer: {
      ...second?.offer,
      cancellationPenalties
    },
    isSplitBooking: true
  });
  const labels = intersection(translatedLabelsFirstOffer, translatedLabelsSecondOffer);
  if (labels.length <= 0) return null;
  return <RoomLabelsText dataId="RoomLabels" className={'container-rooms-label'}>
      {labels.map(label => <RoomLabelsItem key={label}>
          {label}
          {!equals(last(labels), label) && <Dot as="span">·</Dot>}
        </RoomLabelsItem>)}
    </RoomLabelsText>;
};

require("./SingleFlowBundleRoomLabels.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SingleFlowBundleRoomLabels.tsx");